var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"filterable":_vm.filterable,"options":_vm.options,"label":_vm.label,"value":_vm.myValue},on:{"search":_vm.fetchOptions,"open":_vm.onOpen,"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }